"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientForm = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../../app");
const client_1 = require("../../../model/client");
const helpers_1 = require("../../../utils/helpers");
const form_for_1 = require("../../../widgets/form_for");
const modal_1 = require("../../../widgets/modal");
const client_show_1 = require("./client_show");
const client_table_1 = require("./client_table");
function renderForm(form) {
    return (0, mithril_1.default)("div", form.errorBlock(), (0, form_for_1.fieldset)("Information d'identité", {}, (0, helpers_1.ifTrue)(form.isEdit(), form.checkbox("Client actif ?", "enabled")), (0, form_for_1.columns)(form.field("Prénom", "first_name", "text"), form.field("Nom", "last_name", "text")), (0, form_for_1.columns)(form.field("Société", "company_name", "text"), form.field("SIRET", "siret", "text"), form.field("Profession", "job_title", "text")), form.selectField("Régime administratif", "legal_status", app_1.App.CLIENT_TYPE), form.field("Code comptable", "account_code", "text")), (0, form_for_1.fieldset)("Information de contact", {}, form.textarea("Adresse", "address"), (0, form_for_1.columns)(form.field("Code postal", "postal_code", "text"), form.field("Ville", "city", "text")), (0, form_for_1.columns)(form.field("Adresse email", "email", "text"), form.field("Téléphone (portable)", "cellphone", "text"), form.field("Téléphone (fixe)", "telephone", "text"))), (0, form_for_1.fieldset)("Facturation", {}, form.textarea("Adresse de facturation", "invoicing_address"), (0, form_for_1.columns)(form.field("Ville", "invoicing_city", "text"), form.field("Code postal", "invoicing_postal_code", "text"))), (0, form_for_1.fieldset)("Informations légales", {}, (0, mithril_1.default)("h2", "Documents fournis:"), (0, form_for_1.columns)(form.checkbox("Régime administratif", "has_legal_status"), form.checkbox("Assurance", "has_insurance"), form.checkbox("Diplôme", "has_diploma")), (0, form_for_1.columns)(form.checkbox("Document d'identité", "has_identity_document"), form.checkbox("Justificatif de domicile", "has_proof_of_residency"), "")));
}
exports.ClientForm = {
    client: {},
    active: false,
    show(client) {
        this.client = client || {};
        if (client && client.id) {
            client_1.ClientProvider.show(client.id).then((client) => { this.client = client; });
        }
        this.active = true;
    },
    oncreate: () => {
    },
    view(_vnode) {
        if (!exports.ClientForm.active) {
            return undefined;
        }
        let form = (0, form_for_1.formFor)(this.client, client_1.ClientProvider, function (form) {
            return (0, modal_1.modalCard)({
                title: `Nouveau client`,
                content: renderForm(form),
                foot: (0, mithril_1.default)("div", { class: "is-pulled-right" }, form.submit("Envoyer", {
                    onsubmit: (_obj) => {
                        exports.ClientForm.active = false;
                        client_show_1.ClientShow.fetch();
                        client_table_1.ClientTable.fetch();
                    }
                }), (0, mithril_1.default)("button", { class: "button", onclick: (e) => {
                        e.preventDefault();
                        exports.ClientForm.active = false;
                    } }, "Annuler")),
                key: "clientForm",
                isActive: exports.ClientForm.active,
                onClose: () => { exports.ClientForm.active = false; }
            });
        });
        return form;
    }
};
